import { nextTick, ref } from 'vue';
import navigationStore from '@/shared/navigation/navigation.store';

const targetHeight = ref<number>(0);

export default function useDivider() {
    const setDividerHeight = async(el) => {
        if (el) {
            await nextTick(() => {
                targetHeight.value = el.clientHeight;
            });
        } else if (!navigationStore.activeSubNavigationItem) {
            targetHeight.value = 0;
        }
    };

    return {
        setDividerHeight,
        targetHeight,
    };
}
